<template>
  <figure :style="backgroundImageStyle"><slot /></figure>
</template>

<script>
export default {
  name: "meal-image",
  props: ["src"],
  computed: {
    backgroundImageStyle() {
      return {
        "background-image": `url("${this.src || "imgs/placeholder-16-9.png"}")`,
        "background-position": "center center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      }
    }
  }
}
</script>
